import { Box, useMediaQuery, useTheme } from "@mui/material";

export default function Schedule() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <img
        src="img/schedule.png"
        alt="Adam & Tori's wedding schedule"
        style={{
          width: isMobile ? "90%" : "50%",
          boxShadow: "0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
        }}
      />
    </Box>
  );
}
